import z from 'zod';

import {
  GetFilterRequestSchema,
  ListResponseSchema,
} from '../suggestions/schemas.js';

export const AuthenticatePayloadSchema = z.object({
  authorization: z.string(),
});

export const MessagePayloadSchema = z.object({
  status: z.string(),
  message: z.string(),
});

export const SendListPayloadSchema = GetFilterRequestSchema.extend({
  pollInterval: z.number(),
  pageNum: z.number(),
  pageSize: z.number(),
});

export const ListUpdateSchema = z.object({
  data: ListResponseSchema.extend({
    total: z.number(),
  }),
  status: z.string(),
});
